<template>
    <div class="layout-vant-change-popup">
        <van-popup :value="showChange" position="bottom" @click-overlay="clickOverlay">
            <div class="layout-vcp-list" v-if="typeof(changeList) == 'object'">
                <div class="layout-vcp-item" v-for="(data, key) in changeList" v-bind:key="key" v-bind:class="{'layout-vcp-item-cur': data.show}" @click="clickItem(data)">{{data.text}}</div>
            </div>
            <div class="layout-vcp-list" v-else>
                <div class="layout-vcp-item" v-for="data of changeList" v-bind:key="'change' + data.id + Math.random(0, 10)" @click="clickItem(data)">{{data.text}}</div>
            </div>
            <div class="layout-vcp-cancel" @click="clickBottomBtn">{{bottomBtnText}}</div>
        </van-popup>
    </div>
</template>

<script>
export default {
    name : 'VantChangePopup',
    props: ['dataType', 'showChange', 'changeList', 'itemFunc', 'overlayFunc', 'bottomBtnText', 'bottomBtnFunc'],
    methods:{
        clickOverlay() {
            if(typeof(this.overlayFunc) == 'function') {
                this.overlayFunc();
            }
        },
        clickItem(data){
            if(typeof(this.itemFunc) == 'function') {
                this.itemFunc(data)
            }
        },
        clickBottomBtn() {
            if(typeof(this.bottomBtnFunc) == 'function') {
                this.bottomBtnFunc();
            }
        }
    }
}
</script>
